const api_origin = process.env.VUE_APP_API_ORIGIN || "";

function build_safe_url_config() {
  return ({
    allowed_protocols: ["http:", "https:"],
    allowed_origins: [window.location.origin, api_origin].filter(Boolean)
  });
}

export function get_normalized_path(pathname) {
  return pathname.endsWith("/") ? pathname : `${pathname}/`;
}

function require_allowlisted_origin(parsed_url, error_message) {
  const safe_url_config = build_safe_url_config();

  if (!safe_url_config.allowed_protocols.includes(parsed_url.protocol)) {
    throw new Error(error_message);
  }

  if (!safe_url_config.allowed_origins.includes(parsed_url.origin)) {
    throw new Error(error_message);
  }
}

export function require_allowed_endpoint_url(raw_url, allowed_path, error_message) {
  const parsed_url = new URL(String(raw_url || ""), window.location.origin);
  const normalized_path = get_normalized_path(parsed_url.pathname);

  require_allowlisted_origin(parsed_url, error_message);

  if (normalized_path !== allowed_path) {
    throw new Error(error_message);
  }

  parsed_url.pathname = normalized_path;
  return parsed_url;
}

export function require_http_url(raw_url, fallback_origin, error_message) {
  const parsed_url = new URL(String(raw_url || ""), fallback_origin);

  require_allowlisted_origin(parsed_url, error_message);

  return parsed_url.href;
}

function build_xhr_headers(xhr) {
  return ({
    get(header_name) {
      return xhr.getResponseHeader(header_name);
    }
  });
}

function build_xhr_response(xhr) {
  return ({
    ok: xhr.status >= 200 && xhr.status < 300,
    status: xhr.status,
    headers: build_xhr_headers(xhr),
    json() {
      return Promise.resolve().then(() => JSON.parse(xhr.responseText || "null"));
    },
    text() {
      return Promise.resolve(xhr.responseText);
    }
  });
}

function send_xhr_request(safe_url, options) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const request_headers = options?.headers || {};

    xhr.open(options?.method || "GET", safe_url);
    Object.keys(request_headers).forEach((header_name) => {
      xhr.setRequestHeader(header_name, request_headers[String(header_name)]);
    });

    xhr.onload = () => resolve(build_xhr_response(xhr));
    xhr.onerror = () => reject(new Error("Network request failed."));
    xhr.send(options?.body || null);
  });
}

export function fetch_safe_http_url(raw_url, options, fallback_origin, error_message) {
  const safe_url = require_http_url(raw_url, fallback_origin, error_message);

  return send_xhr_request(safe_url, options);
}
